import { render, staticRenderFns } from "./ItemResume.vue?vue&type=template&id=0b489b4b&scoped=true&"
import script from "./ItemResume.vue?vue&type=script&lang=js&"
export * from "./ItemResume.vue?vue&type=script&lang=js&"
import style0 from "./ItemResume.vue?vue&type=style&index=0&id=0b489b4b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b489b4b",
  null
  
)

export default component.exports